<template lang="html">
  <div id="user-home" class="row user-home-page">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 user-home-container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <span v-if="user.thumb">
            <img class="uploading-image img-circle img-responsive" v-bind:src="user.thumb" :alt="translation.profile.altImage + user.name">
          </span>
          <span v-else>
            <img  class="uploading-image img-circle img-responsive" src="../../assets/img/user-home-icon-default.svg" alt="Default Image">
          </span>
        </div>
        <div class="col-lg-12 text-center">
          <h3 class="text-center">{{translation.header.welcome + user.name}}</h3>
        </div>
        <!-- <div class="col-sm-12 text-center text-success" v-show="successPayment">
          <h3>
            {{translation.pets.successPayment}}
            <span v-for="petName in petsCount ">
              {{petName.petName}},
            </span>
            {{translation.pets.successPayment2}}
          </h3>
        </div> -->
        <!-- <div class="col-md-12 user-payment text-left" v-if="payment && showPayment">
          <div class="payment-title">
            <h3>{{translation.payment.paymentTitle}}</h3>
          </div>
          <div class="row">
            <div class="col-sm-4"  v-for="pay in payment">
              <div>
                <p><span class="blue-name">{{pay.petName}}</span></p>
                <p><label :for="pay.petId" class="enabel-label"> {{translation.payment.markForPay}} <input :id="pay.petId" type="checkbox"
                  :value='{petName:pay.petName,petId:pay.petId}' v-model='petsCount'/></label></p>
              </div>
            </div>
            <div class="col-sm-12 text-center border-top" v-show="payButton">
              <div class="row text-center">
                <div class="col-md-4">

                </div>
                <div class="col-md-4">
                  <p>{{translation.payment.redirectBorika}}</p>
                  <a :href="translation.homePage.boricaUrl" target="_blank"><img :src="translation.homePage.boricaSrc" class="img-responsive" alt="Borika" /></a>
                </div>
                <div class="col-md-4">

                </div>
              </div>
              <div class="row">
                <p>{{translation.payment.totalPrice + price + translation.payment.totalCurrency}}</p>
                <div class="col-md-4">
                </div>
                <div class="col-md-4">
                  <a class="payment-button btn"  :href="url" :disabled="paymentDisable">{{translation.payment.pay}}</a>
                </div>
                <div class="col-md-4">
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <router-link to="/user-notificarions">
                <div class="image-container">
                  <img src="../../assets/img/backgrounds/notification-background.svg" alt="Notification Image">
                </div>
                <div class="home-notification text-center">
                  <h4>
                    {{translation.header.notifications}}
                  </h4>
                  <span class="notification-lengt">{{userNotifications.length}}</span>
                  <div class="user-home-text">
                    {{translation.userNotification.notificationDescription}}
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-lg-4 col-md-6">
              <router-link to="/pets-home">
                <div class="image-container">
                  <img src="../../assets/img/backgrounds/pets.svg" alt="Add Pet Image">
                </div>
                <div class="home-notification">
                  <h4 class="text-center">
                    {{translation.pets.pets}}
                  </h4>
                  <div class="user-home-text home-vets">
                    {{translation.pets.yourPets}}
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-lg-4 col-md-6">
              <router-link to="/favorite-vet">
                <div class="image-container">
                  <img src="../../assets/img/backgrounds/vets.svg" alt="Notification Image">
                </div>
                <div class="home-notification">
                  <h4 class="text-center">
                    {{translation.doctor.doctors}}
                  </h4>
                  <div class="user-home-text home-vets">
                    {{translation.doctor.favoriteDoctorsHeader}}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    <div class="col-sm-12 user-home-mobile-container">
      <div class="row">
        <div class="col-sm-12 text-center user-image-home">
          <span v-if="user.thumb">
            <img class="uploading-image img-circle img-responsive" v-bind:src="user.thumb" :alt="translation.profile.altImage + user.name">
          </span>
          <span v-else>
            <img  class="uploading-image img-circle img-responsive" src="../../assets/img/user-home-icon-default.svg" alt="Default Image">
          </span>
        </div>
        <div class="col-sm-12 text-center">
          <h3 class="text-center">{{translation.header.welcome + user.name}}</h3>
          <p></p>
        </div>
        <div class="col-md-12 user-payment text-left" v-if="payment && showPayment">
          <div class="payment-title">
            <h3>{{translation.payment.paymentTitle}}</h3>
          </div>
          <div class="row" v-show="successPayment">
            <div class="col-sm-12 text-center text-success">
              <h3>
                {{translation.pets.successPayment}}
                <span v-for="petName in petsCount ">
                  {{petName.petName}},
                </span>
                {{translation.pets.successPayment2}}
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4"  v-for="pay in payment">
              <div>
                <p><span class="blue-name">{{pay.petName}}</span></p>
                <p><label :for="pay.petId" class="enabel-label"> {{translation.payment.markForPay}} <input :id="pay.petId" type="checkbox"
                  :value='{petName:pay.petName,petId:pay.petId}' v-model='petsCount'/></label></p>
              </div>
            </div>
            <div class="col-sm-12 text-center border-top" v-show="payButton">
              <div class="row text-center">
                <div class="col-md-4">

                </div>
                <div class="col-md-4">
                  <p>{{translation.payment.redirectBorika}}</p>
                  <a :href="translation.homePage.boricaUrl" target="_blank"><img :src="translation.homePage.boricaSrc" class="img-responsive" alt="Borika" /></a>
                </div>
                <div class="col-md-4">

                </div>
              </div>
              <div class="row">
                <p>{{translation.payment.totalPrice + price + translation.payment.totalCurrency}}</p>
                <div class="col-md-4">
                </div>
                <div class="col-md-4">
                  <a class="payment-button btn"  :href="url" :disabled="paymentDisable">{{translation.payment.pay}}</a>
                </div>
                <div class="col-md-4">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <router-link to="/user-notificarions">
                <img src="../../assets/img/backgrounds/mobile-notification.svg" alt="Notification Image">
                <span class="home-notification text-center">
                  <span>
                    <span class="notification-lengt">{{userNotifications.length}}</span>
                    <h4>
                      {{translation.header.notifications}}
                    </h4>
                  </span>
                </span>
              </router-link>
            </div>
            <div class="col-sm-12 col-xs-12">
              <router-link to="/pets-home">
                <span class="image-mobile-container">
                  <img src="../../assets/img/backgrounds/mobile-pets.svg" alt="Add Pet Image">
                </span>
                <span class="home-notification">
                  <h4 class="text-center">
                    {{translation.pets.pets}}
                  </h4>
                </span>
              </router-link>
            </div>
            <div class="col-sm-12 col-xs-12">
              <router-link to="/favorite-vet">
                <span class="image-mobile-container">
                  <img src="../../assets/img/backgrounds/mobile-vet.svg" alt="Notification Image">
                </span>
                <span class="home-notification">
                  <h4 class="text-center">
                    {{translation.doctor.doctors}}
                  </h4>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Footer from '../../components/Footer.vue'
export default {
  data(){
    return {
      translation: null,
      errors: [],
      doctors: [],
      user: [],
      petsCount: [],
      url: '',
      payButton: false,
      showPayment: false,
      price: 0,
      petsCountString: 0,
      successPayment: false,
      paymentDisable: false,
      userNotifications: [],
      payment: [],
      favoriteDoctors: [],
      isSelected: null,
      noResult: false,
      modalBolean: false,
      reviewModal: null,
      petReview:[],
      loader: false,
      paymentId: null,
      options: message.petReview.options,
      days: message.petReview.days,
      doctorSearch:{
        email: '',
        clinic: '',
        country: '',
        city: '',
        neighborhood: ''
      }
    }
  },
  // watch:{
  //   petsCount: function(){
  //     if (this.petsCount) {
  //       this.price = (this.petsCount.length * this.translation.payment.price);
  //       this.payButton = true;
  //       if (this.price == 0 ) {
  //         this.payButton = false;
  //         this.url = '';
  //       }
  //     }
  //     this.userPay();
  //   },
  //   // pay: function(){
  //   //   this.paymentDisable = false;
  //   // }
  // },
  components: {
    Footer
  },
  // mounted(){
  //   this.showPaymentButton();
  // },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.getUser();
    // this.getAllFavoriteDoctors();
    this.getDayNotification();
    // this.getPayment();
    window.pageHeader = this.translation.header.home;
    this.$bus.$on('payment', () => {
      // this.getPayment();
    });
    // this.$bus.$on('add-favorite-doctor', () => {
    //   this.getAllFavoriteDoctors();
    // });
  },
  methods: {
    getUser: function(){
      this.loader = true;
      var self = this;
      axios.get('get-user')
      .then(function (response){
          self.loader = false;
          self.user = null;
          if(response.data.result){
            self.user = response.data.result;
          }
          if (self.user || self.user.lenght) {
            if (self.user.userLoggedIn) {
              localStorage.setItem('userLoggedIn', response.data.result.userLoggedIn);
              localStorage.setItem('language', response.data.result.userLanguage);
              //self.$router.push({ name: 'user-home-page', params: { lang: window.lang } })
            }
          }
          else {
            localStorage.removeItem('userLoggedIn');
            self.$router.push({ name: 'home', params: { lang: window.lang } })
          }
      })
      .catch(err => console.error(err))
    },
    getDayNotification(){
      this.loader = true;
      var self = this;
      axios.get('get-day-notifications')
      .then(function(response){
        self.loader = false;
        if (self.userNotifications = response.data) {
          self.userNotifications = response.data.result;
        }
        else {
          self.userNotifications = [];
        }
      })
      .catch(err => err)
    },
    // userPay(){
    //   var self = this;
    //   var petsId = [];
    //   if (this.petsCount) {
    //     for (var i = 0; i < this.petsCount.length; i++) {
    //       petsId.push(this.petsCount[i].petId)
    //     }
    //   }
    //
    //   this.price = this.price+'';
    //   this.pay = true;
    //   this.petsCountString = this.petsCount.length+'';
    //   axios.get('user-payment', {
    //     params: {
    //       price:self.price,description:self.translation.payment.description,currency:self.translation.payment.totalCurrency,count: self.petsCountString,country:self.translation.payment.totalCurrency,pets: petsId
    //     },
    //     responseType: 'json'
    //   })
    //   .then(function(response){
    //     if (response.data.result.url) {
    //       self.url = response.data.result.url;
    //     }
    //   })
    //   .catch(err => err)
    // },
    // getPayment(){
    //   this.loader = true;
    //   var self = this;
    //   axios.get('get-payment')
    //   .then(function(response){
    //     self.loader = false;
    //     self.payment = response.data.result;
    //     if (self.payment) {
    //       for (var i = 0; i < self.payment.length; i++) {
    //         if (self.payment[i].paymentDate <= 3) {
    //           self.showPayment = true;
    //         }
    //       }
    //     }
    //   })
    //   .catch(err => err)
    // },
    approveNotification(reviewId, notif){
      this.loader = true;
      var formData = this.toFormData({petReviewId: reviewId, notification: notif});
      var self = this;
      axios.post('update-day-notification', formData)
      .then(function(response){
        self.loader = false;
        self.getDayNotification();
      })
      .catch(err => err)
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style>
#user-home{
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;
  background-position: center;
  background-size: cover;
}
#user-home .user-home-container{
  margin-top: 6em;
}
#user-home .user-home-container img{
  display: inline-block;
}
#user-home h3,h4{
  color: #3057B0;
}
#user-home .image-container {
  position: relative;
}
#user-home .notification-lengt {
  display: inline-block;
  background-color: #FE7154;
  width: 2em;
  height: 2em;
  font-size: 1.5em;
  border-radius: 5em;
  color: #fff;
}
#user-home .col-lg-4 .home-notification{
  position: absolute;
  top: 3em;
  left: 0;
  right: 0;
  border-radius: .75em;
}
#user-home .payment-button{
  display: block;
  background: #FE7154;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 2em;
  color: #fff;
}
#user-home .user-home-mobile-container{
  display: none;
}
#user-home .user-home-mobile-container .user-image-home img{
  display: inline-block;
  max-width: 10em;
}
#user-home .footer {
  color: #707070;
}
#user-home .footer .footer-menu {
  text-align: center;
}
#user-home .footer a{
  color: #707070;
}
#user-home .footer a:hover{
  color: #3057B0;
}
#user-home .user-home-text{
  width: 80%;
  margin: 0 auto;
  color: #fff;
  margin-top: 13em;
}
.border-top{
  border-top: 1px solid #707070;
  padding-top: 2em;
}
#user-home .home-vets{
  margin-top: 19em;
}
.user-payment .payment-title{
  border-bottom: 1px solid #707070;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.user-payment .payment-title h3{
  margin-bottom: 0;
  padding: 1em;
}
.user-payment {
  margin-bottom: 2em;
}
.user-payment .row{
  background: #fff;
  padding: 1em;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
}
.user-payment .col-sm-4{
  border-right: 1px solid #707070;
}
.user-payment .col-sm-4:last-of-type{
  border: none;
}
#app #user-home .enabel-label {
  display: block;
}
.enabel-label input {
  display: inline-block;
  width: 3em;
  padding: 1em;
  margin-top: 1em;
}
.blue-name{
  color:#3057B0;
  font-weight: bold;
}
.red-date{
  color: #FE7154;
  font-weight: bold;
}
.enabel-label {
  display: block;
}
@media (max-width: 1620px) {
  #user-home .user-home-text {
      margin-top: 10em;
  }
  #user-home .home-vets{
    margin-top: 13em;
  }
}
@media (max-width: 1366px) {
  #user-home .user-home-text {
      margin-top: 6em;
  }
  #user-home .home-vets{
    margin-top: 10em;
  }
}
@media (max-width: 1200px) {
  #user-home .user-home-text {
      margin-top: 14em;
  }
  #user-home .home-vets{
    margin-top: 21em;
  }
}
  @media (max-width: 1024px) {
    #user-home {
      height: 100%;
    }
    #user-home .user-home-container{
      display: none;
    }
    #user-home .col-sm-12, #user-home .col-xs-12 {
      display: relative;
    }
    #user-home .user-home-mobile-container{
      display: block;
      margin-top: 5em;
    }
    #user-home .col-sm-12 .home-notification, #user-home .col-xs-12 .home-notification{
      position: absolute;
      left: 11em;
      top: 4em;
      right: 0;
    }
  #user-home h4 {
    display: inline-block;
    font-size: 2em;
  }

  #user-home .notification-lengt {
    margin-right: 1em;
    font-size: 2em;
  }
  #user-home .col-sm-12 .home-notification:first-of-type,
  #user-home .col-xs-12 .home-notification:first-of-type {
    left: 0;
  }
  #user-home .user-home-text {
    margin-top: 18em;
  }
  #user-home .home-vets{
    margin-top: 18em;
  }
}
@media (max-width: 768px) {
  #user-home {
    height: 100%;
  }
  #user-home .user-home-container{
    display: none;
  }
  #user-home .col-sm-12, #user-home .col-xs-12 {
    display: relative;
  }
  #user-home .user-home-mobile-container{
    display: block;
    margin-top: 7em;
  }
  #user-home .col-sm-12 .home-notification, #user-home .col-xs-12 .home-notification {
    position: absolute;
    left: 7em;
    top: 4em;
    right: 0;
  }
  #pay-check{
    width: 1em;
  }
  .user-payment .col-sm-4{
    border: none;
    border-bottom: 1px solid #707070;
  }
  #user-home h4 {
    display: inline-block;
    font-size: 1.3em;
  }
  #user-home.footer{
    margin-top: 5em;
  }
  #user-home .notification-lengt {
    margin-right: 1em;
    font-size: 1em;
}
  #user-home .col-sm-12 .home-notification:first-of-type,
  #user-home .col-xs-12 .home-notification:first-of-type {
    left: 0;
  }
}
@media (max-width: 600px) {
  #user-home h4 {
    font-size: 1em;
  }
  #user-home .col-sm-12 .home-notification, #user-home .col-xs-12 .home-notification {
      position: absolute;
      left: 4em;
      top: 1.2em;
      right: 0;
  }
}
</style>
